import { watch, computed, ref, reactive } from 'vue';
import { publicService, layoutService } from '@/api/';
import { tools } from '@/utils/tools';
import useViewFields from '@/hooks/view-fields';
import fP from '@/hooks/field-permission';

export function useAssociationWatch(customForm, entity, op, isCopy = false) {
  const { saveFormData, sendFormData, getComputeing } = useViewFields();
  const { isShowField, isRequiredField, isEditableField } = fP();
  //深拷贝 监听
  const errorDataMap = ref();
  const isFirst = ref(true); //是否第一次加载，第一次的话如果没有赋值规则 就执行一次规则匹配接口
  const isFirstPermission = ref(true); //是否第一次加载业务规则接口
  const ruleFields = ref([]);
  const conditionFields = ref([]); //规则所有配置的字段列表
  const fieldPermission = ref({});
  const isDisabledAll = ref(true); //是否只读全部字段，初始化状态下默认全部只读，配置规则获取完后，放开
  const alreadyAssignKey = ref([]);
  const isDoneFirst = ref(false); //初始化状态
  const deepCloneData = computed(() => {
    return JSON.parse(JSON.stringify(customForm));
  });
  const initFields = reactive({
    jokers: [],
    jokerFields: [],
    fieldKeyReferenceList: [],
    associateFields: []
  });
  //2025年04月16日20:00:35 ruleType是否执行规则接口0.仅执行赋值 1.同时执行所有 2.仅执行规则接口
  const setFormData = async (operation, item) => {
    await saveFormData(null, null, customForm, {}, null);
    const params = {
      eventType: operation,
      layoutConfigId: item?.id,
      fieldKey: item?.setting?.fieldKey,
      entity: entity,
      associateEntity: item?.setting?.fieldExt,
      associateId: item?.fieldValue,
      data: sendFormData.value?.data,
      fieldKeyReferenceList: initFields.fieldKeyReferenceList,
      modules: initFields.associateFields,
      settingId: item?.setting?.id
    };
    const res = await publicService.getAssociationAssignNew(params);
    let isPermission = false;
    if (!res.error) {
      if (res.result && Object.keys(res.result).length > 0) {
        const _tmpData = res.result;
        let numComputer = 0;
        customForm.map((cf) => {
          if (cf?.modules?.length > 0) {
            cf.modules.map((cfm) => {
              if (cfm?.type == 20) {
                //存储这次复制字段信息 防止后续触发的赋值规则，在下次监听触发时清空
                alreadyAssignKey.value = Object.keys(_tmpData);
                if (Object.keys(_tmpData).includes(cfm?.setting?.fieldKey)) {
                  // 统计参与计算字段数量
                  if (cfm?.setting?.idCalculationsFields) numComputer = numComputer + 1;
                  if (conditionFields.value?.includes(`${entity}.${cfm?.setting?.fieldKey}`)) isPermission = true;
                  const key = cfm?.setting?.fieldKey;
                  const fieldType = cfm?.setting?.fieldType == 21 ? cfm?.setting?.business?.fieldType : cfm?.setting?.fieldType;
                  const fieldExt = cfm?.setting?.fieldType == 21 ? cfm?.setting?.business?.fieldExt : cfm?.setting?.fieldExt;
                  if (fieldType == 2 || fieldType == 4) {
                    //2.单选 4.下拉单选
                    cfm.fieldValue = _tmpData[key] || _tmpData[key] === 0 || _tmpData[key] === '0' ? _tmpData[key] : '';
                  } else if (fieldType == 3 || fieldType == 5) {
                    //3.多选 5.下拉多选
                    cfm.fieldValue = _tmpData[key] ? _tmpData[key].split(',') : [];
                  } else if (fieldType == 6) {
                    //6.人员
                    const _user = [];
                    const _name = [];
                    const _list = _tmpData[key] ? (Array.isArray(_tmpData[key]) ? _tmpData[key] : [_tmpData[key]]) : [];
                    _list.forEach((v) => {
                      _user.push({
                        id: v.userId || v.id || '',
                        userName: v.userName,
                        avatarOrigin: v.avatar || v.avatarOrigin || ''
                      });
                      _name.push(v.userName);
                    });
                    cfm.setting['fv'] = {
                      userList: _user,
                      departList: []
                    };
                    cfm.fieldValue = _name;
                  } else if (fieldType == 7) {
                    //7.数字
                    cfm.fieldValue = _tmpData[key] ? Number(parseFloat(_tmpData[key])) : '';
                  } else if (fieldType == 8) {
                    //8.日期
                    cfm.fieldValue = _tmpData[key];
                  } else if (fieldType == 9) {
                    //9.日期范围
                    if (tools.isJSON(_tmpData[key]) && JSON.parse(_tmpData[key])?.beginDate && JSON.parse(_tmpData[key])?.endDate) {
                      cfm.fieldValue = [JSON.parse(_tmpData[key])?.beginDate, JSON.parse(_tmpData[key])?.endDate];
                    } else {
                      cfm.fieldValue = null;
                    }
                  } else if (fieldType == 10) {
                    //10.级联选择器
                    cfm.fieldValue = _tmpData[key] ? _tmpData[key].split('/') : [];
                  } else if (fieldType == 12) {
                    //12.查找关联
                    if (_tmpData[key]?.label && _tmpData[key]?.value) {
                      cfm.fieldValue = _tmpData[key]?.value;
                      //兼容查找关联单选反显
                      cfm['fieldValueName'] = _tmpData[key]?.label;
                    } else {
                      cfm.fieldValue = _tmpData[key];
                      cfm['fieldValueName'] = _tmpData[key];
                    }
                  } else if (fieldType == 16) {
                    //16.金额
                    cfm.fieldValue = tools.getPrice(_tmpData[key], fieldExt ? fieldExt : 2);
                  } else if (fieldType == 18) {
                    //18.附件
                    cfm.fieldValue = _tmpData[key] && tools.isJSON(_tmpData[key]) ? JSON.parse(_tmpData[key]) : [];
                  } else if (fieldType == 22) {
                    //22.部门
                    const _depart = [];
                    const _name = [];
                    const _list = _tmpData[key] ? (Array.isArray(_tmpData[key]) ? _tmpData[key] : [_tmpData[key]]) : [];
                    _list.forEach((v) => {
                      _depart.push({
                        id: v.departmentId || v.id || '',
                        departmentName: v.departmentName || v.name || ''
                      });
                      _name.push(v.departmentName || v.name || '');
                    });
                    cfm.setting['fv'] = {
                      departList: _depart,
                      userList: []
                    };
                    cfm.fieldValue = _name;
                  } else if (fieldType == 23) {
                    //23.百分比
                    cfm.fieldValue = tools.getPercentage(_tmpData[key], JSON.parse(fieldExt)?.numberFormat || 2);
                  } else if (fieldType == 24) {
                    //计算类型
                    if (tools.isJSON(fieldExt)) {
                      const getFieldExt = JSON.parse(fieldExt);
                      if (getFieldExt?.type === 6 || getFieldExt?.type === 16) {
                        // 6:汇总金额类型  16：金额
                        cfm.fieldValue = !isNaN(parseFloat(_tmpData[key])) ? tools.getPrice(_tmpData[key], getFieldExt?.dataType) : '';
                      } else if (getFieldExt?.type === 23) {
                        //百分比
                        cfm.fieldValue = !isNaN(parseFloat(_tmpData[key])) ? tools.getPercentage(_tmpData[key], getFieldExt?.dataType) : '';
                      } else if (getFieldExt?.type === 5 || getFieldExt?.type === 7) {
                        //数字
                        cfm.fieldValue = !isNaN(parseFloat(_tmpData[key])) ? Number(parseFloat(_tmpData[key]).toFixed(getFieldExt?.dataType)) : '';
                      } else {
                        cfm.fieldValue = _tmpData[key] ?? '';
                      }
                    }
                  } else if (fieldType == 25) {
                    //25.查找关联多选
                    if (_tmpData[key]?.[0]?.label && _tmpData[key]?.[0]?.value) {
                      cfm.fieldValue = _tmpData[key]?.map((v) => v?.value);
                      //兼容查找关联单选反显
                      cfm['fieldValueName'] = _tmpData[key]?.map((v) => v?.label);
                    } else {
                      cfm.fieldValue = _tmpData[key];
                    }
                  } else {
                    cfm.fieldValue = _tmpData[cfm?.setting?.fieldKey];
                  }
                }
              }
            });
          }
        });
        if (numComputer > 0) formulasChange();
      }
    }
    //如果查找赋值中触发了规则配置 再次执行一遍规则接口
    if (isPermission) await getFieldPermission();
  };

  /**
   * @brief 从condition中获取相关字段
   */
  const getConditionFields = (condition, jf) => {
    if (condition?.children?.length) {
      condition?.children?.forEach((c) => {
        if (c?.children?.length) {
          c?.children?.forEach((cc) => {
            jf.push(cc.field);
          });
        }
      });
    }
  };

  /**
   * @brief 初始化获取字段信息【引用字段、joker字段】
   */
  const getInitField = () => {
    const _jokers = [];
    const _jokerFields = [];
    const _fieldKeyReferenceList = [];
    const _associateFields = [];
    customForm?.forEach((cf) => {
      if (cf?.modules) {
        cf?.modules.forEach((cfm) => {
          if (cfm.type == 20) {
            if (cfm.setting.fieldType == 21) {
              //引用字段
              const getFieldExt = JSON.parse(cfm?.setting?.fieldExt);
              const _findIndex = _fieldKeyReferenceList?.findIndex((f) => f?.fieldKey == getFieldExt?.findAssociateField);
              if (_findIndex > -1) {
                _fieldKeyReferenceList[_findIndex].referenceFields.push(getFieldExt?.referenceField);
                _fieldKeyReferenceList[_findIndex].findAssociateFields.push(cfm?.setting?.fieldKey);
              } else {
                _fieldKeyReferenceList.push({
                  fieldKey: getFieldExt?.findAssociateField,
                  referenceFields: [getFieldExt.referenceField],
                  findAssociateFields: [cfm?.setting?.fieldKey]
                });
              }
            }
            if (cfm.setting.fieldType == 12) {
              //查找关联单选
              _associateFields.push({
                fieldKey: cfm?.setting?.fieldKey,
                id: cfm?.id
              });
            }
            if (cfm.display == 2) {
              //满足条件显示
              _jokers.push({ type: 2, field: cfm.value, conditions: cfm.displayConditions });
              getConditionFields(cfm?.displayConditions, _jokerFields);
            }
            if (cfm.isRequired == 2) {
              //满足条件必填
              _jokers.push({ type: 1, field: cfm.value, conditions: cfm.requiredConditions });
              getConditionFields(cfm?.requiredConditions, _jokerFields);
            }
          }
          if (cfm.type == 30 || cfm.type == 35) {
            //表格，子表单
            //此处子表单field实际应该传递fieldKey，但是后端接口不支持也没有调整接口的意愿，前端添加兼容在校验时子表单进行双重验证
            if (cfm.display == 2) {
              //满足条件显示
              _jokers.push({ type: 2, field: cfm.id, conditions: cfm.displayConditions });
              getConditionFields(cfm?.displayConditions, _jokerFields);
            }
            if (cfm.isRequired == 2) {
              //满足条件必填
              _jokers.push({ type: 1, field: cfm.id, conditions: cfm.requiredConditions });
              getConditionFields(cfm?.requiredConditions, _jokerFields);
            }
          }
          if (cfm.type == 35) {
            //子表单--子字段
            cfm?.modules?.forEach((el) => {
              //子字段满足条件必填
              if (el.isRequired == 2) {
                _jokers.push({ type: 1, field: cfm.value + '.' + el.value, conditions: el.requiredConditions });
                getConditionFields(el?.requiredConditions, _jokerFields);
              }
            });
          }
        });
      }
    });
    initFields.jokers = _jokers;
    initFields.jokerFields = _jokerFields;
    initFields.fieldKeyReferenceList = _fieldKeyReferenceList;
    initFields.associateFields = _associateFields;
  };

  /**
   * @brief 获取计算字段的值
   */
  const formulasChange = async () => {
    const { formData, errorMap } = await getComputeing(op);
    customForm = formData;
    errorDataMap.value = errorMap;
  };

  /******** 规则匹配相关 start **********/
  const getDefaultPermission = (fieldKey, type) => {
    const _permissionBak = op?.permissionBak || {};
    return _permissionBak?.[fieldKey]?.[type] ?? 1;
  };

  const getFieldPermission = async (setDisabledAll = false) => {
    //等表单赋值引用等逻辑处理完，再次使用最新的customForm处理数据
    try {
      if (setDisabledAll) {
        isDisabledAll.value = true;
      }
      const sendData = getSendData(true);
      //复制在调用业务规则时不上送id
      if (op?.id && !isCopy) {
        sendData['id'] = op?.id;
      }
      let source = '';
      if (op.type == 30) source = '1';
      if (op.type == 40) source = '2';
      const ruleRes = await layoutService.fieldPermission({
        type: 'DATA',
        value: sendData,
        entity: entity,
        reloadData: true,
        jokers: initFields.jokers,
        source: source
      });
      if (!ruleRes?.error) {
        const resData = ruleRes.result?.permissions;
        const fieldKeys = Object.keys(resData);
        fieldPermission.value = ruleRes.result?.permissions;
        const _configs = [];
        ruleRes.result?.configs?.forEach((c) => {
          if (c?.indexOf('.') > -1) {
            const _cArr = c.split('.');
            if (_cArr?.length >= 2) {
              _configs.push(`${_cArr[0]}.${_cArr[1]}`);
            } else {
              _configs.push(c);
            }
          } else {
            _configs.push(c);
          }
        });
        conditionFields.value = _configs;
        ruleFields.value = fieldKeys;
        customForm.map((cf) => {
          if (cf?.modules?.length > 0) {
            cf.modules.map((cfm) => {
              if (cfm?.type == 20) {
                const _jokerIndex = initFields.jokers.findIndex((j) => j.field == cfm?.setting?.fieldKey);
                if (fieldKeys.includes(cfm?.setting?.fieldKey) || _jokerIndex > -1) {
                  //编辑页面负责人不可编辑
                  cfm.businessData = op.type != 30 && !isCopy && cfm?.setting?.fieldKey == 'chargePerson' ? 0 : isEditableField(cfm?.setting?.fieldKey, resData, getDefaultPermission(cfm?.setting?.fieldKey, 'businessData'));
                  cfm.isRequired = isRequiredField(cfm?.setting?.fieldKey, resData, getDefaultPermission(cfm?.setting?.fieldKey, 'isRequired'));
                  cfm.display = isShowField(cfm?.setting?.fieldKey, resData, getDefaultPermission(cfm?.setting?.fieldKey, 'display'));
                } else {
                  cfm.businessData = getDefaultPermission(cfm?.setting?.fieldKey, 'businessData');
                  cfm.isRequired = getDefaultPermission(cfm?.setting?.fieldKey, 'isRequired');
                  cfm.display = getDefaultPermission(cfm?.setting?.fieldKey, 'display');
                }
              } else if (cfm?.type == 30) {
                //关联对象表格
                const _jokerIndex = initFields.jokers.findIndex((j) => j.field == cfm?.id);
                if (fieldKeys.includes(cfm?.value) || _jokerIndex > -1) {
                  cfm.modules = cfm.modules?.filter((cfmm) => {
                    return cfmm?.type != 40 || isEditableField([cfm?.value, cfm?.id], resData, getDefaultPermission(cfm?.value || cfm?.id, 'businessData'));
                  });
                  cfm.isRequired = isRequiredField([cfm?.value, cfm?.id], resData, getDefaultPermission(cfm?.value || cfm?.id, 'isRequired'));
                  cfm.display = isShowField([cfm?.value, cfm?.id], resData, getDefaultPermission(cfm?.value || cfm?.id, 'display'));
                } else {
                  cfm.modules = cfm.modules?.filter((cfmm) => {
                    return cfmm?.type != 40 || getDefaultPermission(cfm?.value || cfm?.id, 'businessData');
                  });
                  cfm.isRequired = getDefaultPermission(cfm?.value || cfm?.id, 'isRequired');
                  cfm.display = getDefaultPermission(cfm?.value || cfm?.id, 'display');
                }
              } else if (cfm?.type == 35) {
                const _jokerIndex = initFields.jokers.findIndex((j) => j.field == cfm?.id);
                if (fieldKeys.includes(cfm?.value) || _jokerIndex > -1) {
                  cfm.isRequired = isRequiredField([cfm?.value, cfm?.id], resData, getDefaultPermission(cfm?.value, 'isRequired'));
                  cfm.display = isShowField([cfm?.value, cfm?.id], resData, getDefaultPermission(cfm?.value, 'display'));
                } else {
                  cfm.isRequired = getDefaultPermission(cfm?.value, 'isRequired');
                  cfm.display = getDefaultPermission(cfm?.value, 'display');
                }

                if (cfm?.modules?.length) {
                  cfm?.modules?.map((cfmm) => {
                    const _subJokerIndex = initFields.jokers.findIndex((j) => j.field == `${cfm?.value}.${cfmm?.value}`);
                    if (fieldKeys.includes(`${cfm?.value}.${cfmm?.value}`) || _subJokerIndex > -1) {
                      const _isRequired = isRequiredField(`${cfm?.value}.${cfmm?.value}`, resData, getDefaultPermission(`${cfm?.value}.${cfmm?.value}`, 'isRequired'));
                      cfmm.businessData = isEditableField(`${cfm?.value}.${cfmm?.value}`, resData, getDefaultPermission(`${cfm?.value}.${cfmm?.value}`, 'businessData'));
                      cfmm.isRequired = _isRequired;
                      cfmm.setting.isRequired = _isRequired;
                      cfmm.display = isShowField(`${cfm?.value}.${cfmm?.value}`, resData, getDefaultPermission(`${cfm?.value}.${cfmm?.value}`, 'display'));
                    } else {
                      const _isRequired = getDefaultPermission(`${cfm?.value}.${cfmm?.value}`, 'isRequired');
                      cfmm.businessData = getDefaultPermission(`${cfm?.value}.${cfmm?.value}`, 'businessData');
                      cfmm.isRequired = _isRequired;
                      cfmm.setting.isRequired = _isRequired;
                      cfmm.display = getDefaultPermission(`${cfm?.value}.${cfmm?.value}`, 'display');
                      // if (isFirstPermission.value) {
                      //   const _permissionBak = cfm.permission && tools.isJSON(cfm.permission) ? JSON.parse(cfm.permission) : {};
                      //   if (_permissionBak?.canEdit == 1 && _permissionBak?.detail?.edit == 1) {
                      //     cfmm.businessData = '1';
                      //   } else {
                      //     cfmm.businessData = '0';
                      //   }
                      // }
                    }
                  });
                }
              }
            });
          }
        });
        isDoneFirst.value = true;
      }
      isFirstPermission.value = false;
      isDisabledAll.value = false;
    } catch (e) {
      isDisabledAll.value = false;
      console.log(e);
    }
  };

  /**
   * @brief 获取上送接口的表单值（key=>value格式）
   */
  const getSendData = (isText = false) => {
    const sendData = {};
    customForm?.forEach((item) => {
      if (item?.modules) {
        item?.modules.forEach((list) => {
          if (list.type == 20) {
            sendData[list?.setting?.fieldKey] = getFormFieldValue(list, isText);
          }
        });
      }
    });

    return sendData;
  };

  /**
   * @brief 获取上送需要的字段值
   * @param list
   * @param isText 查找关联是否使用label文本
   */
  const getFormFieldValue = (list, isText = false) => {
    let fieldValue = list?.fieldValue;
    const fieldType = list.setting.fieldType == 21 ? list?.setting?.business?.fieldType : list.setting.fieldType;
    const fieldExt = list.setting.fieldType == 21 ? list?.setting?.business?.fieldExt : list.setting.fieldExt;
    if (fieldType === 3 || fieldType === 5) {
      fieldValue = fieldValue && Array.isArray(fieldValue) ? fieldValue?.join(',') : null;
    } else if (fieldType === 6) {
      //人员传递参数是字符串ID以逗号分割
      const userIds = list.setting?.fv?.userList?.map((u) => u.id)?.join(',');
      fieldValue = userIds || '';
    } else if (fieldType === 9) {
      const hasValue = tools.hasDateRange(fieldValue);
      const v = { beginDate: fieldValue?.[0], endDate: fieldValue?.[1] };
      fieldValue = hasValue ? JSON.stringify(v) : '';
    } else if (fieldType === 10) {
      fieldValue = fieldValue && Array.isArray(fieldValue) ? fieldValue?.join('/') : '';
    } else if (fieldType === 12) {
      if (isText) {
        fieldValue = {
          label: fieldValue?.label || list?.customValue?.name || list?.fieldValueName || fieldValue || '',
          value: fieldValue?.value || list?.customValue?.value || fieldValue || ''
        };
      } else {
        fieldValue = fieldValue?.value || list?.customValue?.value || fieldValue || '';
      }
    } else if (fieldType === 16) {
      fieldValue = tools.setPrice(fieldValue) || '';
    } else if (fieldType === 18) {
      fieldValue = fieldValue ? JSON.stringify(fieldValue) : '';
    } else if (fieldType === 23) {
      fieldValue = fieldValue ? tools.setPercentage(fieldValue) : null;
    } else if (fieldType === 22) {
      //部门传递参数是字符串ID以逗号分割
      const departIds = list.setting?.fv?.departList?.map((u) => u.id)?.join(',');
      fieldValue = departIds || '';
    } else if (fieldType === 24) {
      //计算类型
      if (fieldExt && tools.isJSON(fieldExt)) {
        if (JSON.parse(fieldExt)?.type == 6 || JSON.parse(fieldExt)?.type == 16) {
          //6：汇总金额  16：金额
          fieldValue = tools.setPrice(fieldValue) || '';
        } else if (JSON.parse(fieldExt)?.type == 23) {
          //百分比
          fieldValue = fieldValue ? tools.setPercentage(fieldValue, JSON.parse(fieldExt)?.dataType) : '';
        }
      }
    } else if (fieldType === 25) {
      fieldValue = list?.customValue?.[0]?.label ? list?.customValue?.map((v) => v.label)?.join(',') : list?.fieldValueName?.length > 0 ? list?.fieldValueName?.join(',') : null;
    } else {
      fieldValue = list?.fieldValue;
    }

    return fieldValue;
  };
  /******** 规则匹配相关 end **********/

  // 获取 关联对象名称的值
  const setFollowFormat = () => {
    let key = '';
    customForm?.forEach((list) => {
      if (list?.modules?.length) {
        list.modules.forEach((item) => {
          if (item?.setting?.fieldKey == 'entityType') {
            key = item.fieldValue;
          }
        });
      }
    });
    return key;
  };
  watch(
    deepCloneData,
    async (newValue, oldValue) => {
      const values = [];
      let _isRule = false;
      let isCompute = false;
      let isEntityType = false;
      console.log(newValue, 'console.log(newValue');
      newValue.forEach((nv, index) => {
        if (nv?.modules?.length > 0) {
          nv.modules.forEach((nvm) => {
            if (nvm?.type == 20) {
              const oldFV = oldValue?.[index]?.modules?.filter((ovm) => ovm?.setting?.fieldKey == nvm?.setting?.fieldKey)?.[0]?.fieldValue || '';
              const newFv = nvm?.fieldValue || '';
              //2025年05月16日17:59:11 多个查找关联关联相同对象只执行第一个 执行多个规则无意义
              const isExistKey = values?.findIndex((v) => v?.item?.setting?.fieldExt == nvm?.setting?.fieldExt);
              if ((op?.type == 30 || !isFirst.value) && nvm?.setting?.fieldType == 12 && oldFV != newFv && isExistKey == -1 && !alreadyAssignKey.value?.includes(nvm?.setting?.fieldKey)) {
                values.push({
                  oldV: oldFV,
                  newV: nvm?.fieldValue,
                  item: nvm
                });
              }
              if (nvm?.setting?.idCalculationsFields && oldFV != newFv) {
                isCompute = true;
              }
              if (op.entity == 16 && nvm?.setting?.fieldKey == 'entityType' && oldFV != newFv) {
                isEntityType = true;
              }
              //如果有规则字段，则需要进行规则接口调用 使用json字符串判断，防止数组对象等无法判断相同
              if (JSON.stringify(oldFV) != JSON.stringify(newFv) && (conditionFields.value?.includes(`${entity}.${nvm?.setting?.fieldKey}`) || initFields.jokerFields?.includes(nvm?.setting?.fieldKey))) {
                _isRule = true;
              }
            }
          });
        }
      });
      //跟进记录初始化时不进行entityType处理，因为从其他对象列表点击过来带了两个参数
      if (isEntityType && !isFirst.value) {
        //如果是跟进记录并且用户调整了entityType字段 需要同步更新businessId字段数据
        customForm.map((cf) => {
          if (cf?.modules?.length > 0) {
            cf.modules.map((cfm) => {
              if (cfm?.type == 20 && cfm?.setting?.fieldKey == 'businessId') {
                cfm.followEntity = setFollowFormat();
                cfm.fieldValue = null;
              }
            });
          }
        });
      }
      //判断逻辑走完清空已经赋值列表，监听到下次改变不影响赋值
      alreadyAssignKey.value = [];
      if (isFirst.value || _isRule) {
        if (isFirst.value) {
          isFirst.value = false;
          //初始化获取相关字段信息
          await getInitField();
          if (op.type == 30 && !isCopy) {
            //如果是新建 并且不是复制，首次打开时执行一次计算字段赋值
            await formulasChange();
          }
          //首次初始化时 设置disabledAll 所有字段不可编辑
          await getFieldPermission(true);
        } else {
          await getFieldPermission();
        }
      }
      if (!isFirst.value && isCompute) {
        await formulasChange();
      }
      if (values.length > 0) {
        await Promise.all(
          values.map(async (_value) => {
            const { oldV, newV, item } = _value;
            //新增页面执行一次时，判断防止''和null一直轮询触发，两者至少有一个有值
            const isEmptyOld = oldV == '' || oldV == null;
            const isEmptyNew = newV == '' || newV == null;
            if (!isEmptyOld || !isEmptyNew) {
              let operation = null;
              if (isEmptyOld && !isEmptyNew) {
                operation = 0;
              } else if (!isEmptyOld && isEmptyNew) {
                operation = 2;
              } else if (!isEmptyNew && !isEmptyOld) {
                operation = 1;
              }
              await setFormData(operation, item);
            }
          })
        );
      }
    },
    //2025年04月16日20:22:08改为任意都会开始监听触发，不过type=30【新建】的时候会再次触发赋值规则
    { deep: true, immediate: true }
  );

  return {
    errorDataMap,
    fieldPermission,
    isDisabledAll,
    isDoneFirst
  };
}
